import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lz-text-lg lz-font-medium lz-text-current" }

import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'
import events from '@/events'
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import LzIcon from '@/components/base/LzIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LzVerticalAccordion',
  props: {
    generalClass: { default: '' },
    open: { type: Boolean, default: false },
    group: {},
    title: {}
  },
  emits: ['toggle'],
  setup(__props: any, { emit }) {

const props = __props;



const isOpen = ref(props.open)

onBeforeMount(() => {
    events.$on('accordion-open', onAccordionOpened)
})

onBeforeUnmount(() => {
    events.$off('accordion-open', onAccordionOpened)
})

function onAccordionOpened(group: string) {
    if (props.group && props.group === group) {
        isOpen.value = false
    }
}

function toggle() {
    if (!isOpen.value) {
        if (props.group) {
            events.$emit('accordion-open', props.group!)
        }
    }
    isOpen.value = !isOpen.value
    emit('toggle', isOpen.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.generalClass)
  }, [
    _renderSlot(_ctx.$slots, "header", {
      accordionOpen: isOpen.value,
      accordionToggle: toggle
    }, () => [
      _createElementVNode("div", {
        class: "lz-relative lz-flex lz-cursor-pointer lz-items-center lz-justify-between",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
      }, [
        _renderSlot(_ctx.$slots, "title", { accordionOpen: isOpen.value }, () => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(LzIcon, {
            name: isOpen.value ? 'minus' : 'plus',
            class: "w-4 h-4 lz-stroke-current lz-transition-transform lz-duration-150 lz-ease-in-out"
          }, null, 8, ["name"])
        ])
      ])
    ]),
    _withDirectives(_createVNode(CollapseTransition, null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", { accordionToggle: toggle })
      ]),
      _: 3
    }, 512), [
      [_vShow, isOpen.value]
    ])
  ], 2))
}
}

})